export enum Types {
  BUTTON = 'button',
  RESET = 'reset',
  SUBMIT = 'submit',
}
